import React from 'react';
import ContentLoader from 'react-content-loader';

const ChartLoader = (props) => (
  <ContentLoader
    height={props.height}
    width={props.width}
    speed={2}
    primaryColor="#f3f3f3"
    secondaryColor="#d6d3d3"
    {...props}
  >
    <rect x="87.58" y="58.67" rx="0" ry="0" width="0" height="0" />
    <circle cx="269.69" cy="70.67" r="1" />
    <rect x="81.53" y="99.67" rx="0" ry="0" width="0" height="0" />
    <rect x="59.28" y="114.67" rx="0" ry="0" width="21" height="46" />
    <rect x="98.84" y="96.67" rx="0" ry="0" width="22.41" height="63" />
    <rect x="139.55" y="73.67" rx="0" ry="0" width="26.86" height="85" />
    <rect x="178.55" y="54.67" rx="0" ry="0" width="22" height="107" />
    <rect x="216.55" y="35.67" rx="0" ry="0" width="27" height="128" />
    <rect x="259.55" y="16.67" rx="0" ry="0" width="26" height="145" />
    <rect
      x="48.54"
      y="161.87"
      rx="0"
      ry="0"
      width="107"
      height="3"
      transform="rotate(-50.17, 48.54, 161.87)"
    />
    <rect
      x="119.71"
      y="78.52"
      rx="0"
      ry="0"
      width="90"
      height="3"
      transform="rotate(58.41, 119.71, 78.52)"
    />
    <rect x="319.23" y="62.67" rx="0" ry="0" width="0" height="0" />
    <rect x="313.23" y="85.67" rx="0" ry="0" width="0" height="0" />
    <rect
      x="148.03"
      y="113.65"
      rx="0"
      ry="0"
      width="223.48"
      height="2.56"
      transform="rotate(-25.17, 148.03, 113.65)"
    />
  </ContentLoader>
);
export default ChartLoader;
